<template>
  <QDialog v-model="showDialog">
    <QCard class="lease-inclusion-dialog full-width q-pa-md" style="max-width: 768px">
      <QCardSection class="column items-center q-pa-none q-ma-none full-width scroll">
        <QCardSection class="column q-pa-none full-width">
          <QBtn
            rounded
            class="calculator-dialog-close"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="handleClose"
          >
            Close
          </QBtn>

          <QCardSection class="q-pa-md flex flex-center">
            <h4 class="stepper-header-title-modal q-mb-md font-baloo">Enquire now</h4>
            <div class="q-pa-sm font-nunito">
              <EnquireNowPage
                :showCustomerSelectionSection="true"
                :vehicle="vehicle"
                descriptionText="Interested to find out more about FleetPartners Operating Leases for your business?<br />
Simply fill in the form below and one of our leasing specialists will contact you shortly about your vehicle enquiry and answer any questions you have all obligation-free."
              />
            </div>
          </QCardSection>
        </QCardSection>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn } from 'quasar';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import EnquireNowPage from '../../../pages/Calculator/EnquireNowPage.vue';

export default {
  props: {
    value: {
      type: Boolean
    },
    vehicle: {
      type: Object
    }
  },
  name: 'EnquireNowModal',
  data: function () {
    return {
      showDialog: false,
      closeIconCircle: evaCloseCircleOutline
    };
  },
  created() {
    this.showDialog = this.value;
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        this.showDialog = this.value;
        // do your stuff
      }
    }
  },
  methods: {
    handleClose() {
      this.showDialog = false;
      this.$emit('onClose', false);
    }
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn,
    EnquireNowPage
  }
};
</script>
<style lang="sass" scoped>
.stepper-header-title-modal
  color: $primary
  font-size: 32px
  text-align: center;
@media (max-width:768px)
  .stepper-header-title-modal
    font-size: 24px
</style>
